var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckRouting = function SvgCheckRouting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 400 140"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40h230M20 70h360M20 120h200"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 30,
    x: 280,
    y: 10,
    fill: "transparent",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250 120h130"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    strokeLinecap: "round",
    d: "M275.709 116.896c24.022-19.598 32.662-12.011 24.655-.211m-.211.211c12.011-9.693 21.283-8.85 16.647-.632m.211 0c4.004-4.004 10.747-4.215 7.797.211"
  }))));
};
export default SvgCheckRouting;